<template>
  <div>
    <div
      v-if="!fieldTypeId"
      class="form-group"
    >
      <v-layout style="height:50px;">
        <v-select
          v-model="fieldType.atomic_type"
          :items="atomicTypeOptions"
          :item-value="'value'"
          :item-text="'name'"
          label="Field Type"
        >
          <template v-slot:append>
            <v-btn
              flat
              small
              @click.stop="selectingReusableField = true"
            >
              <v-icon left>mdi-repeat-variant</v-icon>
              Select Reusable Fieldtype
            </v-btn>
          </template>
        </v-select>
      </v-layout>
    </div>
    <ReusableFieldSelector
      v-if="selectingReusableField"
      @cancel="selectingReusableField = false"
      @save="saveReusableField(arguments[0])"
    />
    <v-card
      v-if="fieldType.name"
      style="margin-top:10px"
    >
      <v-toolbar
        dense
        flat
      >
        <div
          style="background: #2196f3;width:25px;display:inline-block;"
        >
          <v-icon
            color="white"
          >
            mdi-repeat-variant
          </v-icon>
        </div>
        <div
          style="padding-left:10px"
        >
          Reusable Field Type
        </div>
        <v-spacer />
        <v-btn
          flat
          small
          :to="{name: 'OrgSelectedFieldtype', params: {id: fieldType.id}}"
        >
          Edit in Organization Settings
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div>
          <h2>
            {{fieldType.name}}
          </h2>
          <div>
            <em>{{fieldType.desc || ''}}</em>
          </div>
          <div
            style="border-top: 1px solid rgba(26,26,26,0.3);width:100%;height:1px;margin:10px 0 10px 0;"
          >
          </div>
          <p
            v-if="fieldType.required"
            style="color: red;"
          >
            <b>* Required!</b>
          </p>
          <p
            v-if="fieldType.option_list_object"
          >
            <b>Options: </b> {{printOptionLists(fieldType.option_list_object)}}
          </p>
          <div
            v-if="fieldType.mask_pattern"
          >
            <b>Mask Pattern: </b> <span style="background:rgba(26,26,26,0.05);font-family:monospace;">{{fieldType.mask_pattern}}</span>
          </div>
          <div
            v-if="fieldType.regex_pattern"
          >
            <b>RegEx Pattern: </b> <span style="background:rgba(26,26,26,0.05);font-family:monospace;">{{fieldType.regex_pattern}}</span>
          </div>
          <div
            v-if="fieldType.validation_message"
          >
            <b>Validation Message: </b> {{fieldType.validation_message}}
          </div>
          <div
            v-if="[null, 'custom', 'list'].includes(fieldType.atomic_type)"
          >
            <div
              v-if="fieldType.subfieldtypes"
            >
              <v-card
                v-for="ft in fieldType.subfieldtypes"
                :key="ft.id"
                style="margin-bottom:5px; padding: 5px;"
              >
                <v-chip
                  small
                  label
                  style="text-transform:capitalize;"
                >
                  {{ ft.atomic_type_name }}
                </v-chip>
                {{ft.text}} &nbsp;&nbsp;&nbsp;<span v-if="ft.required" style="color:red;">* Required</span>
                <div
                  style="padding-left: 15px"
                >
                  <div
                    v-if="ft.option_list"
                  >
                    <b>Options: </b>
                    <span
                      v-if="showOptList(ft.option_list)"
                    >
                      {{printOptionLists(getOpts[ft.option_list])}}
                    </span>
                    <span
                      v-else
                    >
                      <em>Fetching...</em> {{getPrintOptionLists(ft.option_list)}}
                    </span>
                  </div>
                  <div
                    v-if="ft.mask_pattern"
                  >
                    <b>Mask Pattern: </b> <span style="background:rgba(26,26,26,0.05);font-family:monospace;">{{ft.mask_pattern}}</span>
                  </div>
                  <div
                    v-if="ft.regex_pattern"
                  >
                    <b>RegEx Pattern: </b> <span style="background:rgba(26,26,26,0.05);font-family:monospace;">{{ft.regex_pattern}}</span>
                  </div>
                  <div
                    v-if="ft.validation_message"
                  >
                    <b>Validation Message: </b> {{ft.validation_message}}
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </div>
        <v-switch
          v-if="fieldType.subfieldtypes.length > 0 && !questionId"
          :value="isList"
          label="List"
          hint="Set question as a list, allowing multiple answers"
          persistent-hint
          @change="$emit('update:isList', $event)"
        />
      </v-card-text>
    </v-card>
    <v-card
      v-if="isList"
      style="margin-top: 5px"
    >
      <div
        style="background: rgba(26,26,26,0.1);padding: 5px;padding-left: 15px;width: 100%;"
      >
        List Options
      </div>
      <div
        style="padding: 10px"
      >
        <v-text-field
          v-model="valMinRows"
          label="Minimum Required Rows"
          type="number"
          min="1"
          persistent-hint
          hint="Requires a contact answer a minimum number of rows"
          @input="$emit('update:minRows', arguments[0])"
          class="mb-4"
        />
        <v-text-field
          v-model="valdefaultRows"
          label="Default Rows"
          type="number"
          min="1"
          persistent-hint
          hint="Default number of rows to display when empty"
          @input="$emit('update:defaultRows', arguments[0])"
          class="mb-4"
        />
        <v-text-field
          v-model="valMaxRows"
          label="Maximum Rows"
          type="number"
          min="1"
          persistent-hint
          hint="Maximum number of rows that can be added"
          @input="$emit('update:maxRows', arguments[0])"
          class="mb-4"
        />
        <v-checkbox
          v-model="isAListTable"
          label="Display as Table"
          @change="$emit('update:isListTable', arguments[0])"
          persistent-hint
          hint="Displays as a table, when device width allows."
          class="mt-0"
        />
      </div>
    </v-card>
    <div
      v-if="!fieldType.name"
    >
      <v-checkbox
        v-if="!(isCustom || isList)"
        v-model="fieldType.required"
        label="Required"
      />
      <OptionListBuilder
        v-if="showOptionListBuilder"
        ref="optionListBuilder"
        v-model="fieldType.option_list"
        @loading="$emit('loading', arguments[0])"
      />
      <div
        v-if="fieldType.atomic_type == 'regex'"
      >
        <v-card>
          <v-card-text>
            <v-select
              v-if="!fieldType.id"
              :items="GlobalRegexPatterns"
              label="Select a pattern"
              item-text="name"
              return-object
              @change="updatePattern($event)"
            />
            <v-text-field
              v-model="mask_pattern"
              :disabled="disabledRegexFields"
              label="Mask Pattern"
            />
            <v-text-field
              v-model="regex_pattern"
              :disabled="disabledRegexFields"
              label="Regex Validation Pattern"
            />
            <v-text-field
              v-model="validation_message"
              :disabled="disabledRegexFields"
              label="Validation Error Message"
            />
          </v-card-text>
        </v-card>
      </div>
      <div
        v-if="isCustom || isList"
        style="margin-top: 5px"
      >
        <h4>Subfield Types</h4>
        <Draggable
          v-model="fieldType.subfieldtypes"
          :draggable="'.' + draggableClassName"
          handle=".handle"
          :animation="150"
          easing="cubic-bezier(1, 0, 0, 1)"
        >
          <SubFieldType
            v-for="(subFieldType, index) in fieldType.subfieldtypes"
            ref="subFieldTypes"
            :key="index"
            :class="draggableClassName"
            :id.sync="subFieldType.id"
            :atomicType.sync="subFieldType.atomic_type"
            :optionListId.sync="subFieldType.option_list"
            :text.sync="subFieldType.text"
            :required.sync="subFieldType.required"
            :validationMessage.sync="subFieldType.validation_message"
            :regexPattern.sync="subFieldType.regex_pattern"
            :maskPattern.sync="subFieldType.mask_pattern"
            :questionId="questionId"
            :fieldTypeCLID.sync="subFieldType.clid"
            @loading="$emit('loading', arguments[0])"
          />
          <div slot="footer">
            <v-btn
            color="white"
            small
            @click="addSubFieldType"
            >
              Add
            </v-btn>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters, mapActions } from 'vuex'
import Draggable from 'vuedraggable'
import OptionListBuilder from './OptionListBuilder'
import SubFieldType from './SubFieldType'
import GlobalConstants from '@/globals'
import ReusableFieldSelector from './ReusableFieldSelector'

export default {
  name: 'FieldType',
  props: [ 'fieldTypeId', 'minRows', 'defaultRows', 'maxRows', 'isList', 'isListTable', 'elFieldType', 'questionId', 'newName', 'newCLID' ],
  components: {
    Draggable,
    OptionListBuilder,
    ReusableFieldSelector,
    SubFieldType
  },
  data () {
    return {
      GlobalConstants: null,
      GlobalRegexPatterns: GlobalConstants.GlobalRegexPatterns,
      newFieldType: {
        atomic_type: 'text',
        option_list: null,
        subfieldtypes: []
      },
      atomicTypeOptions: GlobalConstants.AtomicFieldTypes.concat([
        {name: 'List', value: 'list'},
        {name: 'Custom', value: 'custom'}
      ]),
      isAListTable: this.isListTable,
      valdefaultRows: this.defaultRows ? JSON.parse(JSON.stringify(this.defaultRows)) : 0,
      valMinRows: this.minRows ? JSON.parse(JSON.stringify(this.minRows)) : 0,
      valMaxRows: this.maxRows ? JSON.parse(JSON.stringify(this.maxRows)) : 0,
      disabledRegexFields: false,
      selectingReusableField: false,
      reuse_ft: null,
      regex_pattern: '',
      validation_message: '',
      mask_pattern: '',
      getOpts: {}
    }
  },
  created () {
    if (this.fieldType.id) {
      this.regex_pattern = JSON.parse(JSON.stringify(this.fieldType.regex_pattern))
      this.validation_message = JSON.parse(JSON.stringify(this.fieldType.validation_message))
      this.mask_pattern = JSON.parse(JSON.stringify(this.fieldType.mask_pattern))
    }
  },
  computed: {
    ...mapGetters('formtemplate', [
      'fieldTypeById'
    ]),
    fieldType () {
      if (this.reuse_ft) return this.reuse_ft
      let fieldType = this.fieldTypeById(this.fieldTypeId) || this.newFieldType
      if (fieldType.subfieldtypes.length) {
        if (!this.isList) {
          fieldType.atomic_type = 'custom'
        } else {
          fieldType.atomic_type = 'list'
        }
      }
      if (fieldType.atomic_type === 'list' || this.elFieldType === 'list') {
        this.$emit('update:isList', true)
      } else {
        this.$emit('update:isList', false)
      }

      return fieldType
    },
    maxRowsValue () {
      return this.valMaxRows || null
    },
    defaultRowsValue () {
      return this.valdefaultRows || null
    },
    minRowsValue () {
      return this.valMinRows || null
    },
    isCustom () {
      return this.fieldType.atomic_type === 'custom' || this.elFieldType === 'custom'
    },
    showOptionListBuilder () {
      return (this.fieldType.atomic_type === 'dropdown' || this.fieldType.atomic_type === 'checkbox' || this.fieldType.atomic_type === 'radio')
    },
    draggableClassName: function () {
      return 'draggable-item-for-fieldtype-' + this.fieldTypeId
    }
  },
  methods: {
    ...mapActions('formtemplate', [
      'saveFieldType'
    ]),
    showOptList (option) {
      if (option in this.getOpts)
        return true
      else
        return false
    },
    updatePattern (event) {
      this.validation_message = event.validation_message
      this.regex_pattern = event.regex_pattern
      this.mask_pattern = event.mask_pattern
      this.disabledRegexFields = event.name !== "Custom Pattern"
    },
    printOptionLists (opts) {
      var text = ""
      opts.options.forEach((o, i) => {
        if (i == 10) {
          text += "and " + (opts.options.length - 10) + " more"
          return
        }
        if (i > 10)
          return
        text += o.text
        if (i !== opts.options.length - 1)
          text += ", "
      })
      return text
    },
    getPrintOptionLists (opt) {
      api.formtemplate.optionList.get(opt)
        .then(optionList => {
          this.getOpts[opt] = optionList
          this.$forceUpdate()
        })
    },
    saveReusableField (id) {
      api.formtemplate.fieldType.get(id)
        .then((ft) => {
          this.reuse_ft = ft
          this.$emit('selectReusable')
          this.$emit('save', ft)
        })
        .finally(() => {
          this.selectingReusableField = false
        })
    },
    addSubFieldType () {
      this.fieldType.subfieldtypes.push(
        {
          id: null,
          atomic_type: 'text',
          text: null,
          required: false
        }
      )
    },
    saveOptionList () {
      if (this.showOptionListBuilder) {
        return this.$refs.optionListBuilder.save()
      } else {
        return Promise.resolve()
      }
    },
    save () { 
      this.$emit('loading', true)
      return this.saveOptionList()
        .then(() => {
          try {
            return (this.isCustom || this.isList) ? Promise.all(
              this.$refs.subFieldTypes.map(subFieldType => subFieldType.save())
            ) : Promise.resolve()
          } catch (e) {
            // eslint-disable-next-line
            console.log(e)
          }
        })
        .then(() => {
          return this.saveFieldType({
            id: this.fieldTypeId,
            atomic_type: (this.fieldType.atomic_type === 'custom' || this.fieldType.atomic_type === 'list') ? null : this.fieldType.atomic_type,
            option_list: this.fieldType.option_list,
            subfieldtypes: this.fieldType.subfieldtypes,
            mask_pattern: this.mask_pattern !== "" ? this.mask_pattern : null,
            regex_pattern: this.regex_pattern !== "" ? this.regex_pattern : null,
            validation_message: this.validation_message !== "" ? this.validation_message : null,
            required: this.fieldType.required,
            name: this.newName !== null ? this.newName : null,
            ...(this.newCLID !== null && {clid: this.newCLID})
          })
          .then(fieldType => {
            this.$emit('save', fieldType)
          })
        })
    }
  }
}
</script>
